import React from 'react';
import ToggleButton from './toggle-button.component';
import CollapsableContent from './collapsable-content.component';
import { useCollapsableCardContext } from './collapsable-card-context';

export interface CollapsableCardProps {
  children?: React.ReactNode;
  header: string;
  id: string;
  subheader: string;
}

export default function CollapsableCard({ children, header, id, subheader }: CollapsableCardProps) {
  const { isTooLong } = useCollapsableCardContext();
  const isContentTooLong = isTooLong(id);

  return (
    <div className="padding-y-4 tablet:grid-col-9 border-bottom border-base-lighter" data-testid="message-col">
      <h2 className="font-heading-lg text-bold">{header}</h2>
      <h5 className="margin-top-1 text-normal font-heading-md text-gray-50">{subheader}</h5>
      <CollapsableContent id={id}>{children}</CollapsableContent>
      {isContentTooLong && (
        <div className="margin-top-3">
          <ToggleButton controls={id} />
        </div>
      )}
    </div>
  );
}
